import { Row, Col, Card, Button, Skeleton } from "antd";
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import Main from "../../components/layout/Main";
import apiPath from "../../constants/apiPath";
import { Badge } from 'antd';
import { PRICE } from "../../constants/conts";
import moment from "moment";

function View() {

  const params                =   useParams();
  const { request }           =   useRequest();
  const [list, setList]       =   useState({});
  const [loading, setLoading] =   useState(false);

  const fetchData = (id) => {
    setLoading(true);
    request({
      url: apiPath.viewDiscount + "/" + id,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  useEffect(() => {
    fetchData(params.id)
  }, [])

  return (
    <Main>
      <Card title="Discount Details">
        <Row gutter={16}>
          <Col span={12} xs={24} md={24}>
            
            {loading ? [1,2,3].map(item => <Skeleton active key={item} />) :
              <div className="view-main-list">

                <div className="view-inner-cls">
                  <h5>Code:</h5>
                  <h6>{list.code}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>From Date:</h5>
                  <h6>{list.from_date}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>To Date:</h5>
                  <h6>{list.to_date}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>Type:</h5>
                  <h6 className="cap">{list.type}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>{'Min Order Amount ('+PRICE +')'}: </h5>
                  <h6>{list && list.min_amount ? list.min_amount : '-'}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>{'Amount ('+PRICE +')'}: </h5>
                  <h6>{list && list.amount ? list.amount : '-'}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>Percentage: </h5>
                  <h6>{list && list.percentage ? list.percentage+'%': '-'}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>Status:</h5>
                  <h6>{list.is_active ? <Badge colorSuccess status="success" text="Active" /> : <Badge status="error" text="InActive" />}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>Created On:</h5>
                  <h6>{list.created_at ? moment(list.created_at).format('DD-MM-YYYY') : '-'}</h6>
                </div>

                <div className="view-inner-cls float-right">
                  <Link className="ant-btn ant-btn-default" to="/discount/">Back</Link>
                </div>

              </div>
            }

          </Col>
        </Row>
      </Card>
    </Main >
  );
}


export default View;
